import { ErrorBoundary } from 'react-error-boundary'
import { strVal } from '../../modules/Utils'
import React from 'react'
import { Button, Select, Spin, Tooltip } from 'antd'
import { get } from 'lodash'
import useFetch from './useFetch'

export default function useFetchSelect({
  url,
  dependencyArray = [],
  dontFetch = false,
  mapFunction = (i) => i,
  dataFunction = (i) => i,
  accessor,
  queryKey = url,
  isExternal = false,
}) {
  const { data, fetching, fetch, isFetching } = useFetch({
    url,
    dependencyArray,
    dontFetch,
    queryKey,
    isExternal,
    mapFunction,
    dataFunction,
  })

  const [selected, setSelected] = React.useState({})

  let options = accessor ? get(data, accessor, []) : data
  options = Array.isArray(options) ? options : []

  const SelectData = (props) => {
    const {
      value,
      onChange = () => console.log('No Onchange'),
      placeholder = 'Select an option',
      keyAtr = '_id',
      valueAtr = 'name',
      setSelected: setExternalSelected,
    } = props

    if (fetching) return <Spin spinning={fetching} />

    const select = options.find((i) => get(i, keyAtr) === value)

    setSelected(select)

    if (setExternalSelected) setExternalSelected(select)

    const getValue = (c) => get(c, valueAtr) || get(c, 'name') || get(c, 'fn') || get(c, keyAtr)

    options.sort((a, b) => getValue(a).localeCompare(getValue(b)))
    // options = sortData(options)

    return (
      <Tooltip
        placement="top"
        mouseEnterDelay={1}
        mouseLeaveDelay={0.5}
        title={<Button onClick={fetch}>Refresh dropdown</Button>}
        trigger="hover">
        <div className="flex">
          {isFetching && (
            <div className="mx-2">
              <Spin />
            </div>
          )}
          <Select
            // style={{ width: '100%' }}
            {...props}
            className="w-full"
            defaultValue={value}
            showSearch
            // ref={ref}
            allowClear
            filterOption={(input, option) =>
              strVal(option, 'props.children').toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={(e) => {
              onChange(e)
              setSelected(options.find((i) => get(i, keyAtr) === e))
            }}
            placeholder={placeholder}>
            {options.map((c) => (
              <Select.Option key={`${get(c, keyAtr)}`} value={get(c, keyAtr)} title={get(c, valueAtr)}>
                {getValue(c)}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Tooltip>
    )
  }

  React.useEffect(() => {
    fetch()
    return () => {}
  }, dependencyArray)

  return { SelectData, data, fetching, fetch, selected }
}
